//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class BlogCategoryService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[BlogCategory.Create]
	async create(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/cms/blog-category/create', params || { });
	};

	//GeneratorFlag:[BlogCategory.Delete]
	async delete(blogCategoryId, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		const params = {
			id:blogCategoryId
		}
	
		return await _server.delete('/cms/blog-category/delete', {'params':params})
	};

	//GeneratorFlag:[BlogCategory.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/cms/blog-category/detail', {'params':params});
	};

	//GeneratorFlag:[BlogCategory.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/cms/blog-category/list', {'params':params});
	};

	//GeneratorFlag:[BlogCategory.Update]
	async update(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/cms/blog-category/update', params || { });
	};

//GeneratorFlag:[NewAction]
}